import { Component, OnInit } from '@angular/core';

import { SharedService } from '@services/shared.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

    title = 'Givi Enterprise Gifting';

    constructor(
        public sharedService: SharedService
    ) {
        sharedService.showPreLogin = true;
    }

    ngOnInit(): void {
        
        // Add the event listener of Mobiloud
        // window.addEventListener("message", (event) => {

        //     this.sharedService.setMobiloudApp(event);
        // }, false);
    }
}
